import {Component, inject, Inject, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ApiError} from "../../../core/models/api-error.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ApiRoutesService} from "../../../core/services/api-routes.service";
import {CommunityService} from "../../../core/services/connected/community.service";
import {AuthenticationService} from "../../../core/services/authentication.service";
import {DatePipe} from "@angular/common";
import {Community} from "../../../core/models/community.model";

@Component({
  templateUrl: './manage-relative.dialog.html',
  styleUrls: ['./manage-relative.dialog.scss']
})
export class ManageRelativeDialog implements OnInit {

  readonly #authentService = inject(AuthenticationService);
  readonly #communityService = inject(CommunityService);
  readonly #apiRoutes = inject(ApiRoutesService);
  readonly #datePipe = inject(DatePipe);
  private readonly _dialogRef: MatDialogRef<ManageRelativeDialog>;
  private readonly _community: Community;

  private _profileForm!: FormGroup;
  private _error: ApiError | null = null;
  private _isLoading: boolean = false;
  private _file: File | null = null;
  #pictureUrl: string = "";

  constructor(dialogRef: MatDialogRef<ManageRelativeDialog>, @Inject(MAT_DIALOG_DATA) data: any) {
    this._dialogRef = dialogRef;
    this._community = data.community;

    if (this._community.relative && this._community.relative.hasPicture) {
      this.#pictureUrl = `${this.#apiRoutes.community()}/${this._community.id}/picture?access_token=${this.#authentService.accessToken}&t=${new Date().getTime()}`;
    } else {
      this.#pictureUrl = '/assets/images/default-profile-picture.png';
    }
  }

  ngOnInit(): void {
    this._profileForm = new FormGroup({
      lastName: new FormControl(this._community.relative.lastname, [Validators.required, Validators.maxLength(50)]),
      firstName: new FormControl(this._community.relative.firstname, [Validators.required, Validators.maxLength(50)]),
      nickName: new FormControl(this._community.relative.nickname),
      birthDate: new FormControl(this.#datePipe.transform(this._community.relative.birthDate, 'yyyy-MM-dd'),),
      phone: new FormControl(this._community.relative.phone, [Validators.required, Validators.pattern(/^0[1-9](?:[ .-]?[0-9]{2}){4}$/)]),
    });
  }

  get community(): Community {
    return this._community;
  }

  get pictureUrl(): string {
    return this.#pictureUrl;
  }

  get profileForm(): FormGroup {
    return this._profileForm;
  }

  get error(): ApiError | null {
    return this._error;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  public onClose(): void {
    this._dialogRef.close(null);
  }

  public getFileSelected(fileSelected: File | null) {
    this._file = fileSelected;
  }

  public submit() {
    if (this._profileForm.valid) {
      this._isLoading = true;
      this._error = null;
      this._profileForm.value.birthDate = new Date(this._profileForm.value.birthDate).getTime();

      this.#communityService.updateCommunity(this._community.id, this._profileForm?.value, this._file).subscribe({
        next: (community) => {
          this._dialogRef.close(community);
          this._isLoading = false;
        },
        error: (error) => {
          this._error = error.error;
          this._isLoading = false;
        }
      });
    }
  }
}
